import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../shared/js';

import styles from './typography.module.scss';

const Typography = ({
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  span,
  id,
  sizeOverride,
  children,
  ...props
}) => {
  let Tag;
  if (h1) Tag = 'h1';
  else if (h2) Tag = 'h2';
  else if (h3) Tag = 'h3';
  else if (h4) Tag = 'h4';
  else if (h5) Tag = 'h5';
  else if (h6) Tag = 'h6';
  else if (span) Tag = 'span';
  else Tag = 'p';

  return (
    <Tag
      id={id}
      className={cn(
        styles[sizeOverride],
        // eslint-disable-next-line react/prop-types
        props.className,
        applyClasses(props, styles)
      )}
      {...applyProps(props)}
    >
      {children}
    </Tag>
  );
};

Typography.propTypes = {
  /** The ID of the element. Useful to select the element during testing. */
  id: PropTypes.string,
  /** Create a h1 element */
  h1: PropTypes.bool,
  /** Create a h2 element */
  h2: PropTypes.bool,
  /** Create a h3 element */
  h3: PropTypes.bool,
  /** Create a h4 element */
  h4: PropTypes.bool,
  /** Create a h5 element */
  h5: PropTypes.bool,
  /** Create a h6 element */
  h6: PropTypes.bool,
  /** Creates a span element */
  span: PropTypes.bool,
  /** Creates a p element */
  p: PropTypes.bool,
  /** Left-align the text */
  left: PropTypes.bool,
  /** Center-align the text */
  center: PropTypes.bool,
  /** Right-align the text */
  right: PropTypes.bool,
  /** Override the heading element with a different heading's size. Useful if you want one for semantic reasons, but it shouldn't look like its actual heading */
  sizeOverride: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  /** Automatically adjust the size of a heading at the different breakpoints */
  responsive: PropTypes.bool,
  /** The contents of the heading */
  children: PropTypes.any,
};

Typography.defaultProps = {
  h1: false,
  h2: false,
  h3: false,
  h4: false,
  h5: false,
  h6: false,
  span: false,
  p: false,
  left: true,
  center: false,
  right: false,
  sizeOverride: undefined,
  responsive: false,
  children: undefined,
};

export default Typography;
